/* ==========================================================================
   ОТМОРА — поведение на страницата
   Без зависимости. Всичко деградира до работеща HTML страница без JS.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.OTMORA_CONFIG || {};
  var RATE = CFG.eurRate || 1.95583;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ──────────────── помощни ──────────────── */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // Всички цени в config.js са в ЕВРО — това е валутата на магазина.
  // eur() показва сумата както е; bgn() я преизчислява по фиксирания курс.
  // Никога не хвърля: една липсваща цена не бива да убива целия скрипт,
  // защото тогава спира и бутонът за плащане.
  function fmt(n) {
    n = Number(n);
    if (!isFinite(n)) n = 0;
    return n.toLocaleString('bg-BG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function eur(n) { return fmt(n) + ' €'; }
  function bgn(n) { return fmt(n * RATE) + ' лв.'; }

  function toast(message) {
    var region = $('#toast-region');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="20 6 9 17 4 12"/></svg><span></span>';
    el.querySelector('span').textContent = message;
    region.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () { el.remove(); }, 240);
    }, 3200);
  }

  /* ──────────────── проследяване (пиксели) ──────────────── */

  function track(event, data) {
    try {
      if (window.fbq) window.fbq('track', event, data);
      if (window.ttq && window.ttq.track) window.ttq.track(event, data);
      if (window.gtag) window.gtag('event', event, data || {});
    } catch (e) { /* проследяването никога не бива да чупи поръчката */ }
  }

  function loadPixels() {
    // Facebook
    if (CFG.facebookPixelId) {
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      window.fbq('init', CFG.facebookPixelId);
      window.fbq('track', 'PageView');
      window.fbq('track', 'ViewContent', {
        content_name: 'ОТМОРА N7', content_type: 'product',
        value: CFG.unitPrice, currency: 'BGN'
      });
    }
    // GA4
    if (CFG.ga4MeasurementId) {
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + CFG.ga4MeasurementId;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', CFG.ga4MeasurementId);
    }
  }

  /* ──────────────── UTM параметри (за атрибуция на рекламите) ──────────────── */

  function captureUtm() {
    var p = new URLSearchParams(location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
                'fbclid', 'ttclid', 'gclid'];
    var found = {};
    keys.forEach(function (k) { if (p.get(k)) found[k] = p.get(k); });
    if (Object.keys(found).length) {
      try { sessionStorage.setItem('otmora_utm', JSON.stringify(found)); } catch (e) {}
      return found;
    }
    try { return JSON.parse(sessionStorage.getItem('otmora_utm') || '{}'); } catch (e) { return {}; }
  }
  var UTM = captureUtm();

  /* ──────────────── плавно скролване + фокус върху формата ──────────────── */

  $$('[data-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', id);
      // Достъпност: премести фокуса, за да продължи навигацията с клавиатура оттам.
      setTimeout(function () {
        var firstChoice = $('input[name="bundle"]:checked');
        if (id === '#poruchka' && firstChoice) { firstChoice.focus({ preventScroll: true }); }
        else { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
      }, reduceMotion ? 0 : 520);
    });
  });

  /* ──────────────── галерия ──────────────── */

  (function gallery() {
    var slides = $$('.gallery__slide');
    var thumbs = $$('.gallery__thumb');
    if (!slides.length) return;

    function show(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
      // стрелки наляво/надясно между миниатюрите
      thumb.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % thumbs.length;
        if (e.key === 'ArrowLeft') next = (i - 1 + thumbs.length) % thumbs.length;
        if (next === null) return;
        e.preventDefault();
        thumbs[next].focus();
        show(next);
      });
    });
  })();

  /* ──────────────── калкулация на поръчката ──────────────── */

  var state = { bundle: 1, color: 'Маслинено зелено' };

  // Скритото поле, което Shopify чете при изпращане на формата. Държим го
  // винаги в синхрон с избора — дефинира се тук, преди първото извикване.
  var variantField = $('#variant-id');
  function syncVariantField() {
    if (!variantField || !THEME_MAP) return;
    var byColor = THEME_MAP[state.color];
    var id = byColor && byColor[bundleData(state.bundle).qty];
    if (id) variantField.value = id;
  }

  // В темата цените идват от самите radio бутони, попълнени от Liquid.
  // На статичния сайт се ползва config.js. И в двата случая връщаме нещо валидно.
  function bundleData(key) {
    var input = document.querySelector('input[name="bundle"][value="' + key + '"]');
    if (input && input.getAttribute('data-cents')) {
      var cents = Number(input.getAttribute('data-cents')) || 0;
      var wasCents = Number(input.getAttribute('data-was-cents')) || cents;
      return {
        qty: Number(input.getAttribute('data-qty')) || 1,
        price: cents / 100,
        was: wasCents / 100,
        label: input.getAttribute('data-label') || '',
        money: input.getAttribute('data-money') || null,
        moneyWas: input.getAttribute('data-money-was') || null
      };
    }
    if (CFG.bundles && CFG.bundles[key]) return CFG.bundles[key];
    var unit = Number(CFG.unitPrice) || 0;
    return { qty: 1, price: unit, was: unit, label: '1 брой' };
  }

  // Ако Shopify вече е форматирал сумата, показваме нея — така страницата
  // и касата изписват цената по един и същ начин.
  function money(value, preformatted) {
    return preformatted || eur(value);
  }

  function recalc() {
    var b = bundleData(state.bundle);
    var listPrice = b.was;                       // зачертаната цена, от config
    var discount = listPrice - b.price;

    var tDesc = $('#t-desc'), tSub = $('#t-sub'), tSave = $('#t-save'),
        tTotal = $('#t-total'), tEur = $('#t-eur');

    if (tDesc)  tDesc.textContent  = b.qty + ' × ОТМОРА N7';
    if (tSub)   tSub.textContent   = money(b.price, b.money);
    if (tSave)  tSave.textContent  = '−' + eur(discount);
    if (tTotal) tTotal.textContent = money(b.price, b.money);
    if (tEur)   tEur.textContent   = '/ ' + bgn(b.price);

    var sbLabel = $('#sb-label'), sbPrice = $('#sb-price'), sbEur = $('#sb-eur');
    if (sbLabel) sbLabel.textContent = b.label || (b.qty + ' броя');
    if (sbPrice) sbPrice.textContent = money(b.price, b.money);
    if (sbEur)   sbEur.textContent   = '/ ' + bgn(b.price);

    // Котвата с цената под снимките
    var paPrice = $('#pa-price'), paWas = $('#pa-was'),
        paOff = $('#pa-off'), paEur = $('#pa-eur'), paSub = $('.price-anchor .btn__sub');
    if (paPrice) paPrice.textContent = money(b.price, b.money);
    if (paWas)   paWas.textContent   = money(listPrice, b.moneyWas);
    if (paEur)   paEur.textContent   = bgn(b.price);
    if (paOff)   paOff.textContent   = '−' + Math.round(discount / listPrice * 100) + '%';
    if (paSub) {
      // Спестеното спрямо купуване на същия брой поотделно. Единичната цена
      // идва от варианта «1 брой» — така важи и в темата, където няма config.
      var unit = bundleData(1).price || Number(CFG.unitPrice) || 0;
      var vsSingles = (unit * b.qty) - b.price;
      paSub.textContent = vsSingles > 0.005
        ? b.qty + ' броя · спестявате ' + eur(vsSingles)
        : '1 брой · безплатна доставка';
    }

    syncVariantField();
  }

  $$('input[name="bundle"]').forEach(function (input) {
    input.addEventListener('change', function () {
      state.bundle = input.value;
      recalc();
      track('AddToCart', {
        content_name: 'ОТМОРА N7 ×' + bundleData(state.bundle).qty,
        value: bundleData(state.bundle).price, currency: 'BGN'
      });
    });
  });

  $$('input[name="color"]').forEach(function (i) {
    i.addEventListener('change', function () {
      state.color = i.value;
      syncVariantField();          // цветът също сменя варианта
    });
  });

  // Бутоните „Избери този“ в секцията с комплекти водят право към формата.
  $$('[data-pick-bundle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-pick-bundle');
      var radio = document.querySelector('input[name="bundle"][value="' + key + '"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var card = $('#order-card');
      if (card) {
        card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () {
          var go = $('#submit-btn');
          if (go) go.focus({ preventScroll: true });
        }, reduceMotion ? 0 : 520);
      }
      var picked = bundleData(key);
      toast(picked.qty === 1
        ? 'Избрахте 1 брой — остава само плащането.'
        : 'Избрахте ' + picked.qty + ' броя — остава само плащането.');
    });
  });

  recalc();

  /* ──────────────── към чекаута на Shopify ──────────────── */

  // Постоянна връзка към количката на Shopify:
  //   https://магазин/cart/ВАРИАНТ:1
  // Комплектът е самият вариант (1, 2 или 3 броя със собствена цена),
  // затова количеството е винаги 1 и не са нужни кодове за отстъпка.
  // В темата на Shopify вариантите идват направо от продукта — тогава няма
  // нищо за настройване. На статичния сайт се ползва config.js.
  var THEME_MAP = (function () {
    var el = document.getElementById('otmora-variant-map');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();

  function checkoutUrl() {
    var qty = bundleData(state.bundle).qty;

    if (THEME_MAP) {
      var byColorTheme = THEME_MAP[state.color];
      var id = byColorTheme && byColorTheme[qty];
      return id ? '/cart/' + id + ':1' + utmQuery() : null;
    }

    var sp = CFG.shopify || {};
    if (!sp.domain) return null;

    var byColor = (sp.variants || {})[state.color];
    var variantId = byColor && byColor[qty];
    if (!variantId) return null;

    var url = 'https://' + String(sp.domain).replace(/^https?:\/\//, '').replace(/\/$/, '') +
              '/cart/' + variantId + ':1';

    return url + utmQuery();
  }

  // Пренасяме атрибуцията, за да се вижда в Shopify от коя реклама е поръчката.
  function utmQuery() {
    var params = [];
    Object.keys(UTM).forEach(function (k) {
      params.push(encodeURIComponent(k) + '=' + encodeURIComponent(UTM[k]));
    });
    return params.length ? '?' + params.join('&') : '';
  }

  var form = $('#order-form');

  // В темата формата се изпраща към /cart/add и Shopify поема нататък.
  // Държим скрития вариант винаги в синхрон с избора, за да е верен и
  // ако JS спре да работи по-късно.
  if (form) {
    form.addEventListener('submit', function (e) {
      var btn = $('#submit-btn');
      var b = bundleData(state.bundle);

      track('InitiateCheckout', {
        value: b.price, currency: 'EUR',
        content_name: 'ОТМОРА N7', num_items: b.qty
      });

      // Ако количката е на страницата, тя поема изпращането (cart.js).
      if (document.getElementById('cart-drawer')) {
        syncVariantField();
        return;
      }

      // Тема: формата е истинска Shopify форма — не я спираме.
      if (form.getAttribute('action')) {
        syncVariantField();
        if (variantField && variantField.value) {
          btn.classList.add('is-loading');
          btn.disabled = true;
          return;                      // нативен POST → /cart/add → /checkout
        }
        e.preventDefault();
        toast('Изберете комплект и цвят.');
        return;
      }

      e.preventDefault();
      var target = checkoutUrl();

      if (target) {
        btn.classList.add('is-loading');
        btn.disabled = true;
        // Purchase се отчита от Shopify след реалното плащане, не тук.
        location.href = target;
        return;
      }

      // ДЕМО режим — Shopify още не е настроен. Показваме потвърждение,
      // за да е кликаем сайтът, и записваме избора локално.
      var order = {
        ref: 'OTM-DEMO-' + Math.floor(1000 + Math.random() * 9000),
        bundle: state.bundle, qty: b.qty, product: 'ОТМОРА N7',
        color: state.color, total: b.price,
        totalEur: +(b.price / RATE).toFixed(2), currency: 'BGN',
        createdAt: new Date().toISOString(), source: location.href, utm: UTM
      };
      try {
        var log = JSON.parse(localStorage.getItem('otmora_orders') || '[]');
        log.push(order);
        localStorage.setItem('otmora_orders', JSON.stringify(log));
      } catch (err) {}

      if (window.console) {
        console.info('[ОТМОРА] ДЕМО режим — Shopify не е настроен. ' +
          'Попълнете shopify.domain и shopify.variants в config.js.', order);
      }

      btn.classList.add('is-loading');
      btn.disabled = true;
      setTimeout(function () {
        var refEl = $('#order-ref');
        if (refEl) refEl.textContent = order.ref;
        $('#order-card').classList.add('is-done');
        $('#order-card').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        var bar = $('#sticky-bar');
        if (bar) bar.classList.remove('is-visible');
      }, 600);
    });
  }

  /* ──────────────── лепкава лента (мобилни) ──────────────── */

  (function stickyBar() {
    var bar = $('#sticky-bar');
    var card = $('#order-card');
    if (!bar || !card) return;

    // Лентата се показва, само когато самата форма НЕ се вижда — иначе
    // дублира бутона точно до себе си. Мерим картата, а не цялата секция:
    // на телефон секцията е по-висока от екрана и никога не «излиза».
    function update() {
      var r = card.getBoundingClientRect();
      var cardOnScreen = r.top < window.innerHeight - 120 && r.bottom > 160;
      var scrolledEnough = window.scrollY > 420;
      var finished = card.classList.contains('is-done');
      bar.classList.toggle('is-visible', scrolledEnough && !cardOnScreen && !finished);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    // Втори спусък: наблюдателят се задейства и когато скрол събития са
    // ограничени от браузъра или страницата се отвори вече превъртяна.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(update, { threshold: [0, 0.01, 0.5, 1] }).observe(card);
    }

    update();
  })();

  /* ──────────────── сянка на хедъра при скрол ──────────────── */

  (function headerShadow() {
    var header = $('#header');
    if (!header) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-stuck', window.scrollY > 8);
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ──────────────── таймер на промоцията ──────────────── */

  (function hotOffer() {
    var cfg = CFG.hotOffer || {};
    if (cfg.enabled === false) return;

    var MINUTES = Number(cfg.minutes) || 55;
    var KEY = 'otmora_hot_deadline';

    var bar   = $('#hotbar');
    var clock = $('#hot-clock');
    var textEl = $('#hot-text');
    var labelEl = $('#hot-label');
    var cdM = $('#cd-m'), cdS = $('#cd-s');
    if (!bar && !cdM) return;

    // Крайният час се запомня при първото отваряне, за да не се нулира
    // отброяването на всяко презареждане или при връщане назад.
    function deadline() {
      var now = Date.now();
      var saved = 0;
      try { saved = parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch (e) {}

      if (saved > now) return saved;

      // Изтекла е (или е първо посещение).
      if (saved && cfg.restartWhenExpired === false) return saved;

      var fresh = now + MINUTES * 60000;
      try { localStorage.setItem(KEY, String(fresh)); } catch (e) {}
      return fresh;
    }

    var end = deadline();
    var units = clock ? clock.querySelectorAll('.hotbar__unit') : [];

    function paint(mm, ss) {
      if (units.length === 2) {
        units[0].firstChild.nodeValue = mm;
        units[1].firstChild.nodeValue = ss;
      }
      if (cdM) cdM.textContent = mm;
      if (cdS) cdS.textContent = ss;
    }

    function expired() {
      if (bar) bar.classList.add('is-expired');
      if (labelEl) labelEl.textContent = 'ОФЕРТАТА ИЗТЕЧЕ';
      if (textEl)  textEl.textContent = cfg.expiredText || 'Промоцията приключи';
      if (clock) clock.hidden = true;
      var urgency = document.querySelector('.urgency');
      if (urgency) urgency.hidden = true;
    }

    var timer = setInterval(tick, 1000);

    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);

      if (left <= 0) {
        if (cfg.restartWhenExpired === false) {
          clearInterval(timer);
          paint('00', '00');
          expired();
          return;
        }
        end = deadline();               // ново отброяване
        left = Math.floor((end - Date.now()) / 1000);
      }

      paint(
        String(Math.floor(left / 60)).padStart(2, '0'),
        String(left % 60).padStart(2, '0')
      );
    }

    tick();
    if (bar) bar.hidden = false;        // показваме чак с готово число
  })();

  /* ──────────────── още отзиви ──────────────── */

  (function moreReviews() {
    var btn = $('#more-reviews');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var hidden = $$('.review.is-more[hidden]');
      hidden.forEach(function (el) { el.hidden = false; });
      btn.setAttribute('aria-expanded', 'true');
      btn.remove();
    });
  })();

  /* ──────────────── появяване при скрол ──────────────── */

  (function reveal() {
    var items = $$('.reveal');
    if (!items.length) return;
    // Без наблюдател или при изключени анимации просто не пипаме нищо —
    // съдържанието вече се вижда.
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    items.forEach(function (el) { el.classList.add('is-armed'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });
    items.forEach(function (el) { io.observe(el); });

    // Предпазна мрежа: ако наблюдателят мълчи (спрян рендер, стар браузър,
    // фонов таб), сваляме маскировката, за да не остане страницата празна.
    setTimeout(function () {
      $$('.reveal.is-armed').forEach(function (el) {
        if (!el.classList.contains('is-in')) el.classList.remove('is-armed');
      });
    }, 2500);
  })();

  /* ──────────────── старт ──────────────── */

  loadPixels();
})();
